import {createSlice} from '@reduxjs/toolkit';

// initial state
const initialState = {
    headerHeight: 158
};

// ==============================|| SLICE - MENU ||============================== //

const ui = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setHeaderHeight(state, action) {
            state.headerHeight = action.payload;
        }
    }
});

export default ui.reducer;

export const {setHeaderHeight} = ui.actions;
export const getHeaderHeight = (state) => state.ui.headerHeight;
